module.exports = __webpack_public_path__ + "static/media/progressive.62e65335.svg";